<template>
  <div
    id="lensguide"
    ref="lensGuideBanner"
    :class="$b()"
  >
    <div class="global-wrapper">
      <VisionHeading
        size="h2"
        tag="h3"
        :class="$b('title')"
      >
        {{ $tr('Find your perfect lens with') }}
        <span :class="$b('title', { highlight: true })">
          {{ $tr('Lens Guide.') }}
        </span>
      </VisionHeading>
      <div :class="$b('wrapper')">
        <div v-if="!isInView || !bannerImageReady" class="vision-shimmer" :style="{ width: '100%', height: '100%' }"/>
        <LazyLensGuideBannerImage
          v-if="isInView"
          v-show="isInView && bannerImageReady"
          :customised-product="customisedProduct"
          :selected-scene="selectedScene"
          :show-iris-preview="showIrisPreview"
          @show-lens-guide="$emit('show-lens-guide')"
          @ready="bannerImageReady = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'LensGuideBanner',

  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
    selectedScene: {
      type: String,
      required: true,
    },
    showIrisPreview: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['show-lens-guide'],

  data() {
    return {
      isInView: false,
      bannerImageReady: false
    }
  },

  mounted() {
    if (this.$refs.lensGuideBanner) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isInView = true
            }
          })
        },
        {
          rootMargin: '0px',
          threshold: 0,
        }
      )

      this.observer.observe(this.$refs.lensGuideBanner)
    }
  }
}
</script>

<style lang="postcss">
.LensGuideBanner {
  @apply pt-6 pb-xl bg-black;

  @screen lg {
    @apply pt-10 pb-xl;
  }

  .BaseChoice__outer {
    width: 43px;
    height: 43px;

    @screen md {
      width: 48px;
      height: 48px;
    }

    &:before {
      @apply border-white;
    }
  }

  .BaseChoice--shape-circle {
    @apply pr-xs pointer-events-none;

    @screen md {
      @apply pr-5;
    }
  }
}

.LensGuideBanner__lens-guide-button {
  @apply z-[1];
}

.LensGuideBanner__title {
  @apply mb-16 text-white;

  @screen md {
    @apply mb-20;
  }

  &--highlight {
    @apply t-gradient;
  }
}

.LensGuideBanner__wrapper {
  @apply relative rounded-lg overflow-hidden
    flex items-center justify-center;
  height: 514px;

  @screen md {
    height: 693px;
  }
}

.LensGuideBanner__lens-choice {
  @apply absolute top-0 right-0
    flex items-center justify-center
    text-white
    mx-8 my-7;

  @screen md {
    @apply my-12 mx-16;
  }
}

.LensGuideBanner__base-image,
.LensGuideBanner__preview-image,
.LensGuideBanner__preview-image-wrapper {
  @apply absolute inset-0
    w-full h-full;
}

.LensGuideBanner__preview-image {
  transition: clip-path 0.25s ease;
}

.LensGuideBanner__scene-image {
  @apply w-full h-full
    pointer-events-none
    !max-w-full;

  img {
    @apply h-full object-cover;
  }
}
</style>
